import React from "react";
import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";

const PreviewModal = ({ open, onClose, url }) => {
    const fileName = url?.split("/").pop();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle className="flex justify-between items-center">
                <span>Document Preview</span>
                <Button
                    variant="contained"
                    color="primary"
                    component="a"
                    href={url}
                    download={fileName}
                >
                    Download
                </Button>
            </DialogTitle>

            <DialogContent>
                {/* PDF preview */}
                {url?.endsWith(".pdf") && (
                    <iframe
                        src={url}
                        title="PDF Preview"
                        width="100%"
                        height="600px"
                        style={{ border: "none" }}
                    />
                )}

                {/* Image preview */}
                {(url?.endsWith(".png") ||
                    url?.endsWith(".jpg") ||
                    url?.endsWith(".jpeg")) && (
                        <img src={url} alt="Preview" className="w-full rounded-lg" />
                    )}

                {/* For unsupported file types */}
                {!url?.match(/\.(pdf|png|jpg|jpeg)$/) && (
                    <p>Preview not available for this file type.</p>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default PreviewModal;
